import React, { useMemo, useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { UnorderedList } from '@r1-frontend/ui-react/components/List';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useOnceExecute } from '@r1-frontend/shared/hooks/useOnceExecute';

type TConnectionConditions = {
    isVillage?: boolean,
    analyticsCallback: () => void,
}

const getList = (isVillage = false) => {
    return isVillage
        ? [
            'Доставка необходимого оборудования.',
            'Настройка услуг и&nbsp;личного кабинета.',
            'Помощь с&nbsp;подписанием договора на&nbsp;Госуслугах.',
            'Прокладка интернет-кабеля от&nbsp;оборудования провайдера до&nbsp;вашего дома.',
            'Прокладка кабеля до&nbsp;5&nbsp;метров внутри дома. За&nbsp;каждый дополнительный метр нужно будет доплатить.',
            'При необходимости поможем спрятать кабель или настроить ваше собственное оборудование. Эти услуги оплачиваются отдельно.',
            'Во&nbsp;время работ стоимость может измениться, если для прокладки сети потребуется больше материалов.',
        ]
        : [
            'Выезд сервисного инженера.',
            'Доставка необходимого оборудования.',
            'Настройка услуг и&nbsp;личного кабинета.',
            'Помощь с&nbsp;подписанием договора на&nbsp;Госуслугах.',
            'Прокладка кабеля до&nbsp;5&nbsp;метров внутри квартиры. За&nbsp;каждый дополнительный метр нужно будет доплатить.',
            'При необходимости поможем спрятать кабель или настроить ваше собственное оборудование. Эти услуги оплачиваются отдельно.',
        ];
};

const ConnectionConditions = ({ isVillage, analyticsCallback }: TConnectionConditions): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);


    const handleClosePopup = () => {
        changePopupState(false);
    };

    const triggerAnalytics = useOnceExecute(() => {
        analyticsCallback();
    });


    const handleOpenPopup = () => {
        triggerAnalytics();
        changePopupState(true);
    };

    const list = useMemo(() => getList(isVillage), [isVillage]);

    return (
        <>
            <ControlElement type={'large'} Icon={InfoCircleFlip} onClick={handleOpenPopup}>Подробнее</ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup} $zIndex={1001}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <H3>Что входит в стоимость?</H3>
                    <ListContainer $size={16}>
                        <UnorderedList $color={COLORS.TextInfo}>
                            {React.Children.map(list, item => <Paragraph4 as={'li'} dangerouslySetInnerHTML={{ __html: item }}/>)}
                        </UnorderedList>

                        <ButtonGroup>
                            <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                        </ButtonGroup>
                    </ListContainer>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default ConnectionConditions;
